// src/data/tournaments.js

export const tournamentsData = [

  {
    id: 62,
    title: "II Copa Bushido de Jiu Jitsu Gi 2026",
    link: "ii-copa-bushido-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/ii-copa-bushido-de-jiu-jitsu-2026/ii-copa-bushido-de-jiu-jitsu-2026-home.jpeg"),
    description: `
   <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 160,00 CATEGORIA GI </span><br />
      <span>R$ 70,00 CATEGORIA ABSOLUTO </span><br />
      <span>Pagamento até 10/ABR/2026</span><br />
      <br />
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
   {
    id: 54,
    title: "Open Five de Jiu Jitsu Gi 2026",
    link: "open-five-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/open-five-de-jiu-jitsu-2026/open-five-de-jiu-jitsu-2026.jpeg"),
    description: `
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 105,00 CATEGORIA GI</span> <br />
      <span>Pagamento até 10/ABR/2026</span> <br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 120,00 CATEGORIA GI</span> <br />
      <span style="display: block;">Pagamento até 17/ABR/2026</span><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },


  {
    id: 59,
    title: "Desafio Zona Norte de Jiu Jitsu Gi e Nogi 2026",
    link: "desafio-zona-norte-de-jiu-jitsu-manaus-am-2026",
    image: require("../assets/images/tournaments/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026/desafio-zona-norte-de-jiu-jitsu-manaus-am-2026-banner.jpeg"),
    description: `
       <br />
      <span><b>EVENTO: LUTAS CASADAS</b></span> <br />
      <span>R$ 35,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 70,00 COMBO GI + NOGI</span> <br />
      <br />
      <span>Faixas: Todas as faixas — Mirim ao Master</span> <br />
      <span style="display: block;">Pagamento até 22/ABR/2026</span><br />
    `,
    isCasadas: true,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

     {
    id: 58,
    title: "Campeonato Amazonense de MMA Amador 2026",
    link: "i-campeonato-amazonense-de-mma-amador-2026",
    image: require("../assets/images/tournaments/i-campeonato-amazonense-de-mma-amador-2026/i-campeonato-amazonense-de-mma-amador-2026.jpeg"),
    sport: "MMA",
    description: `
       <br />
      <span><b>INSCRIÇÃO GRATUITA!</b></span><br />
      <span>PERÍODO DE INSCRIÇÃO : 04/MAR/2026 A 15/ABR/2026 </span><br />
      <br />
      <strong style="display: block;">INSCRIÇÕES ATÉ 15 DE ABRIL OU ATÉ ATINGIR A QUANTIDADE DE ATLETAS PERMITIDO.</strong><br />
      <strong style="display: block;color: red;">VAGAS LIMITADAS A 200 INSCRIÇÕES</strong><br />

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 55,
    title: "I Copa BJJ Talent Gi e Nogi 2026",
    link: "i-copa-bjj-talent-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/i-copa-bjj-talent-de-jiu-jitsu-2026/i-copa-bjj-talent-de-jiu-jitsu-2026-banner1.jpeg"),
    description: `
       <br />
      <span><b>EVENTO: LUTAS CASADAS</b></span> <br />
      <span>R$ 35,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 70,00 COMBO GI + NOGI</span> <br />
      <br />
      <span>Faixas: Todas as faixas — Pré-mirim ao Master</span> <br />
      <span style="display: block;">Pagamento até 29/ABR/2026</span><br />
    `,
    isCasadas: true,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 66,
    title: "II Valente Kids de Jiu Jitsu GI",
    link: "ii-valente-kids-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/ii-valente-kids-de-jiu-jitsu-2026/ii-valente-kids-de-jiu-jitsu-2026-home.png"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI </span><br />
      <span>Pagamento até 13/MAI/2026</span><br />

      <strong style="color:red;">
        NÃO HAVERÁ ABSOLUTO NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },


  {
    id: 47,
    title: "Sti Open Kids de Jiu Jitsu Gi e Nogi",
    link: "sti-open-kids-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/sti-open-kids-de-jiu-jitsu-2026/sti-open-kids-de-jiu-jitsu-2026-home.jpeg"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 110,00 CATEGORIA GI (com kimono) OU NOGI (sem kimono)</span> <br />
      <span>R$ 190,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 09/ABR/2026</span> <br />
      
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 120,00 CATEGORIA GI (com kimono) OU NOGI (sem kimono)</span> <br />
      <span>R$ 210,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 30/ABR/2026</span> <br />
      
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 130,00 CATEGORIA GI (com kimono) OU NOGI (sem kimono)</span> <br />
      <span>R$ 220,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 20/MAI/2026</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 65,
    title: "II Open Challenger de Jiu Jitsu Gi e Nogi 2026",
    link: "ii-open-challenger-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/ii-open-chellenger-de-jiu-jitsu-2026/ii-open-challenger-de-jiu-jitsu-2026.jpeg"),
    description: `
   <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI </span><br />
      <span>R$ 130,00 COMBO CATEGORIA GI + NOGI </span><br />
      <span>Pagamento até 25/MAI/2026</span><br />
      <br />
      <strong style="color:red;">
        NÃO HAVERÁ CATEGORIA ABSOLUTO
      </strong>
      <br />
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

     {
    id: 53,
    title: "IV Copa CLBJJ de Jiu Jitsu Gi e Nogi 2026",
    link: "iv-copa-clbjj-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/clbjj-de-jiu-jitsu-2026/clbjj-de-jiu-jitsu-2026.jpeg"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 65,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 20,00 ABSOLUTO GI OU NOGI</span> <br />
      <span>R$ 120,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>R$ 135,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI</span> <br />
      <span>R$ 135,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO NOGI</span> <br />
      <span>R$ 150,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI+ ABSOLUTO NOGI</span> <br />
      <span>Pagamento até 30/ABR/2026</span> <br />
      
      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 30,00 ABSOLUTO GI OU NOGI</span> <br />
      <span>R$ 130,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>R$ 155,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI</span> <br />
      <span>R$ 155,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO NOGI</span> <br />
      <span>R$ 180,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI+ ABSOLUTO NOGI</span> <br />
      <span style="display: block;">Pagamento até 02/JUN/2026</span><br />

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },


{
    id: 60,
    title: "I Etapa Circuito Amazonense FAJJO - GI & NOGI 2026",
    link: "i-circuito-amazonense-fajjo-manaus-am",
    image: require("../assets/images/tournaments/i-circuito-amazonense-fajjo-manaus-am/i-circuito-amazonense-fajjo-manaus-am.PNG"),
    description: `
       <br />
      <span><b>LOTE ÚNICO </b></span> <br />
      <span>COMBO R$100,00 (CATEGORIA GI R$80,00 + R$20,00 FILIAÇÃO COM CARTEIRINHA DIGITAL) </span> <br />
      <span>COMBO R$100,00 (CATEGORIA NOGI R$80,00 + R$20,00 FILIAÇÃO COM CARTEIRINHA DIGITAL)</span> <br />
      <span>COMBO R$150,00 CATEGORIA GI+NOGI + FILIAÇÃO COM CARTEIRINHA DIGITAL</span> <br />
      <span style="display: block;">Pagamento até 08/JUN/2026</span><br />

      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 67,
    title: "LIJJAM Combat IX de Jiu Jitsu Gi e Nogi",
    link: "lijjam-combat-ix-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/lijjam-combat-ix-de-jiu-jitsu-2026/lijjam-combat-ix-de-jiu-jitsu-2026.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 140,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 01/JUN/2026</span><br />

      <span><b>LOTE 2</b></span><br />
      <span>R$ 80,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 160,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 09/JUN/2026</span><br />

      <strong style="color:red;">
        EVENTO DE LUTAS CASADAS
     </strong>
    `,
    isCasadas: true,
    isCacheBuster: true,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 61,
    title: "Vi Open Terra Santa de Jiu Jitsu Gi e Nogi 2026",
    link: "vi-open-terra-santa-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/vi-open-terra-santa-de-jiu-jitsu-2026/vi-open-terra-santa-de-jiu-jitsu-2026.jpeg"),
    description: `
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 140,00 COMBO GI+NOGI</span> <br />
      <span>Pagamento até 15/JUL/2026</span> <br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 80,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 150,00 COMBO GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 22/JUL/2026</span><br />
      
       <span>Faixas: Todas as faixas — Pré-mirim ao Master</span> <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },


 
  {
    id: 64,
    title: "XXXIV Copa Orley Lobato de Jiu Jitsu Gi 2026",
    link: "xxxi-copa-orley-lobato-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/xxxiv-copa-orley-lobato-de-jiu-jitsu-2026/xxxiv-copa-orley-lobato-de-jiu-jitsu-2026-home.jpeg"),
    description: `
   <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI </span><br />
      <span>R$ 40,00 CATEGORIA ABSOLUTO </span><br />
      <span>Pagamento até 05/AGO/2026</span><br />
      <br />
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

/*  {
    id: 63,
    title: "I Campeonato Interno CT Team Kombat de Jiu Jitsu Gi 2026",
    link: "i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026/i-campeonato-interno-ct-team-kombat-de-jiu-jitsu-2026-home.png"),
    description: `
   <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI </span><br />
      <span>Pagamento até 02/SET/2026</span><br />
      <br />
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: false,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  }, */


  // Encerrados


  {
    id: 57,
    title: "Open Cambé de Jiu Jitsu Gi 2026",
    link: "open-cambe-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/open-cambe-de-jiu-jitsu-2026/open-cambe-de-jiu-jitsu-2026.jpeg"),
    description: `
   <br />
     <strong style="color:red; display: block;">
        ⚠️ EVENTO CANCELADO.
      </strong><br />
      <strong style="color:red; display: block;">
        Os pedidos de reembolso serão aceitos até dia 25 de Março de 2026.
      </strong><br />
      <span style="display: block;">O prazo para o Reembolso é de até 30 dias corridos.</span><br />
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSeMeKJktKU9By5TxNTMwLY5kT-_-ApF5THh7hMp8e-szmVXqA/viewform?usp=header" target="_blank" style="color:#FFD700; font-weight:bold; display:block;">
        👉 Clique aqui para solicitar o reembolso
      </a><br />
      <!--
      <strong style="color:red; display: block;">
        ⚠️ ATENÇÃO: INSCRIÇÃO PRORROGADA ATÉ 20/MAR/2026 ÀS 23:59h.
      </strong><br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI </span><br />
      <span>Pagamento até 17/MAR/2026</span><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
      -->
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 45,
    title: "Copa Parintinense de Jiu Jitsu Gi e Nogi",
    link: "copa-parintinense-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/copa-parintinense-de-jiu-jitsu-2026/copa-parintinense-de-jiu-jitsu-2026-home.jpeg"),
    description: ` 
       <br />/>
      
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 70,00 ABSOLUTO GI OU NOGI</span> <br />
      <span>R$ 210,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI</span> <br />
      <span>R$ 210,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO NOGI</span> <br />
      <span>R$ 280,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI+ ABSOLUTO NOGI</span> <br />
      <span style="display: block;">Pagamento até 25/MAR/2026</span><br />
      

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 52,
    title: "Copa Amizade de Jiu Jitsu GI",
    link: "copa-amizade-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2026/copa-amizade-de-jiu-jitsu-2026.jpeg"),
    description: `
      <br />
      <strong style="color:red; display: block;">
        ⚠️ ATENÇÃO: INSCRIÇÃO PRORROGADA ATÉ 26/MAR/2026 ÀS 23:59h.
      </strong><br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 155,00 CATEGORIA GI </span><br />
      <span>Pagamento até 25/MAR/2026</span><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 44,
    title: "Circuito Internacional de Jiu Jitsu Gi e Nogi - Sinppfpr",
    link: "circuito-internacional-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/circuito-internacional-de-jiu-jitsu-2026/circuito-internacional-de-jiu-jitsu-2026-home.jpeg"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
     <!--<strong style="color: red;">
        VÁLIDO PARA AS 200 PRIMEIRAS INSCRIÇÕES PAGAS
      </strong> -->
      <br />
      <span>R$ 99,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 139,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 31/JAN/2026</span> <br />
      
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 129,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 169,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 10/MAR/2026</span> <br />
      
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 169,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 199,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 19/MAR/2026</span><br />

       <strong style="color: red;">
        CAMISA DO EVENTO, GRÁTIS PARA AS 100 PRIMEIRAS INSCRIÇÕES PAGAS.
      </strong><br />
      <br />
      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },


    {
    id: 56,
    title: "Circuito FAJJE COARI - GI & NO GI",
    link: "circuito-fajje-coari-de-jiu-jitsu-coari-am",
    image: require("../assets/images/tournaments/circuito-fajje-coari-de-jiu-jitsu-coari-am/circuito-fajje-coari-de-jiu-jitsu-coari-am.jpeg"),
    description: `
       <br />
      <span><b>VALOR ÚNICO (SEM LOTE DE DESCONTO)</b></span> <br />
      <span>R$ 50,00 CATEGORIA GI</span> <br />
      <span>R$ 50,00 CATEGORIA NO GI</span> <br />
      <span>R$ 100,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 06/MAR/2026</span><br />

      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true,
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 46,
    title: "II Copa Mercosul de Jiu Jitsu Gi e Nogi",
    link: "ii-copa-mercosul-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/ii-copa-mercosul-de-jiu-jitsu-2026/ii-copa-mercosul-de-jiu-jitsu-2026-home.jpg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA GI OU NOGI </span><br />
      <span>R$ 200,00 COMBO CATEGORIA GI+NOGI </span><br />
      <span>Pagamento até 13/MAR/2026</span><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
 
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 49,
    title: "I Grand Slam Estadual de Jiu Jitsu Feminino Gi 2026",
    link: "i-grand-slam-estadual-de-jiu-jitsu-feminino-2026",
    image: require("../assets/images/tournaments/i-grand-slam-estadual-de-jiu-jitsu-feminino-2026/i-grand-slam-estadual-de-jiu-jitsu-feminino-2026.jpeg"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 90,00 CATEGORIA GI</span> <br />
      <span>R$ 50,00 ABSOLUTO</span> <br />
      <span>Pagamento até 20/FEV/2026</span> <br />
      
      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 100,00 CATEGORIA GI </span> <br />
      <span>R$ 60,00 ABSOLUTO</span> <br />
      <span style="display: block;">Pagamento até 05/MAR/2026</span><br />
    

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  
  {
    id: 50,
    title: "VIII Copa Campeões de Jiu Jitsu Gi 2026",
    link: "viii-copa-campeoes-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/viii-copa-campeoes-de-jiu-jitsu-2026/vii-copa-campeoes-de-jiu-jitsu-2026-home.png"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 120,00 CATEGORIA GI</span> <br />
      <span>R$ 70,00 ABSOLUTO</span> <br />
      <span>Pagamento até 01/MAR/2026</span> <br />
      
      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 150,00 CATEGORIA GI </span> <br />
      <span>R$ 70,00 ABSOLUTO</span> <br />
      <span style="display: block;">Pagamento até 05/MAR/2026</span><br />
    

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 51,
    title: "IV Seletiva Manaus Olímpica de Jiu Jitsu GI 2026",
    link: "seletiva-manaus-olimpica-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/seletiva-manaus-olimpica-2026/seletiva-manaus-olimpica-2026.png"),
    description: `
      <br />
      <span><b>INSCRIÇÃO GRATUITA!</b></span><br />
      <span>PERÍODO DE INSCRIÇÃO : 18/FEV/2026 A 20/FEV/2026 </span><br />
      <br />
      <span style="color: red; display: block;">INSCRIÇÕES SERÃO ABERTAS ÀS 13:00H</span><br />
      <strong style="display: block;">INSCRIÇÕES ATÉ 20 DE FEVEREIRO OU ATÉ ATINGIR A QUANTIDADE DE ATLETAS PERMITIDO.</strong><br />
      <strong style="display: block;color: red;">VAGAS LIMITADAS A 1.600 INSCRIÇÕES</strong><br />
      
 
    `,
    isCacheBuster: false,
    amountRegistrationPaid: true,
    maxInscricoes: 1600,
    ajusteQuantidadeDeInscricoes: -70,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: true,
    quantidadeInscricaoEstatica: 1600
  },

  {
    id: 43,
    title: "XIX Copa Paraná de Jiu Jitsu Gi e Nogi",
    link: "xix-copa-parana-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/xix-copa-parana-de-jiu-jitsu-2026/xix-copa-parana-de-jiu-jitsu-2026.jpeg"),
    description: `
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 120,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 200,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 15/JAN/2026</span> <br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 140,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 220,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 15/FEV/2026</span> <br />

      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 160,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 250,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 19/FEV/2026</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
    {
    id: 48,
    title: "Campeonato de Jiu Jitsu Gladiadores Able Bjj Judô",
    link: "campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026",
    image: require("../assets/images/tournaments/campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026/campeonato-de-jiu-jitsu-gladiadores-able-bjj-judo-2026.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 10,00 CATEGORIA GI </span><br />
      <span>Pagamento até 11/FEV/2026</span><br />
      <br />
      <strong style="display: block;">NÃO HAVERÁ INSCRIÇÃO PARA ABSOLUTO NESTE EVENTO</strong><br />
 
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

 {
    id: 42,
    title: "Copa Arapongas de Jiu Jitsu GI",
    link: "copa-arapongas-de-jiu-jitsu-2026",
    image: require("../assets/images/tournaments/copa-arapongas-de-jiu-jitsu-2026/copa-arapongas-de-jiu-jitsu-2026-home.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 140,00 CATEGORIA GI </span><br />
      <span>Pagamento até 06/FEV/2026</span><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
 
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

   {
    id: 6,
    title: "Open Laranjeiras do Sul de Jiu Jitsu",
    link: "open-laranjeiras-do-sul-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-laranjeiras-do-sul-de-jiu-jitsu-2025/open-laranjeiras-do-sul-de-jiu-jitsu-2025.jpeg"),
    description: `
    <br />
    <strong style="color:red; display: block;">
        ⚠️ ATENÇÃO: INSCRIÇÃO PRORROGADA ATÉ 09/JAN/2025 ÀS 23:59h.
      </strong><br />
     
     <!-- <strong style="color:red; display: block;">
        ⚠️ ATENÇÃO: Devido à mudança da data do evento por causa do TORNADO, somente quem se inscreveu antes da alteração poderá pedir reembolso até 22/NOV/2025. Após essa data, não haverá reembolso.
      </strong><br />  -->
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 110,00 CATEGORIA GI</span><br />

      <span>Pagamento até 20/DEZ/2025</span> <br />
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />

      <span>Pagamento até 02/JAN/2026</span><br />
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 140,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 06/JAN/2026</span><br />
  
      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />
  
      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 41,
    title: "Estadual GF Team Amazonas de Jiu Jitsu Gi e Nogi - Etapa Careiro",
    link: "estadual-gfteam-amazonas-de-jiu-jitsu-2025-etapa-careiro",
    image: require("../assets/images/tournaments/estadual-gfteam-amazonas-de-jiu-jitsu-2025-etapa-careiro/estadual-gfteam-amazonas-de-jiu-jitsu-2025-etapa-careiro.png"),
    description: `
      <br />
      <strong style="color:red;">
        PRORROGADO!
      </strong><br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 50,00 CATEGORIA GI OU NOGI </span><br />
      <span>R$ 100,00 COMBO CATEGORIA GI+NOGI </span><br />
      <span style="color:red;" ><b>Pagamento até 18/DEZ/2025 às 23:59</span></b><br />
      <br />
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
 
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  
  {
    id: 10,
    title: "I COPA FAIXA SOLIDÁRIA DE JIU JITSU 2025",
    link: "i-copa-faixa-solidaria-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/i-copa-faixa-solidaria-de-jiu-jitsu-2025/i-copa-faixa-solidaria-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span style="display: block;">
        <b>VALOR DA INSCRIÇÃO: </b>
        <br /> 
        2KG DE ALIMENTOS NÃO PERECÍVEIS , DEVERÁ SER ENTREGUE NO MOMENTO DA PESAGEM.
      </span><br />

       <span style="display: block;">
        PERÍODO DE INSCRIÇÃO: 05/NOV/2025 ATÉ 10/NOV/2025.
      </span><br />

      <span style="color: red; display: block;">INSCRIÇÕES SERÃO ABERTAS ÀS 18:00H</span><br />

      <span >
        <b>
          VAGAS LIMITADAS A 1.000 INSCRIÇÕES, (SOMANDO CATEGORIA 
          E ABSOLUTO).
        </b>
      </span>
      <br />
      <span style="color: red;">
        <b>
         INSCRIÇÕES ENCERRADAS!!!
        </b>
      </span>
      <br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: true,
    maxInscricoes: 1000,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: true,
    quantidadeInscricaoEstatica: 1000
  },


  {
    id: 100,
    title: "COPA OPEN EXTREME MANAUS DE JIU JITSU",
    link: "copa-open-extreme-manaus-de-jiu-jitsu",
    image: require("../assets/images/tournaments/copa-open-extreme-manaus-de-jiu-jitsu-2025/copa-open-extreme-manaus-de-jiu-jitsu-home.jpg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 35,00 CATEGORIA GI</span><br />
      <span>R$ 35,00 ABSOLUTO GI</span><br />
      <span>Pagamento até 30/NOV/2025</span><br />
      <br />
      <br />
      <!-- <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br /> -->
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 9,
    title: "Toledo Open Brazilian de Jiu Jitsu Gi e Nogi",
    link: "toledo-open-brazilian-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/toledo-open-brazilian-de-jiu-jitsu-2025/toledo-open-brazilian-de-jiu-jitsu-2025.jpeg"),
    description: ` 
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 100,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 150,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 20/NOV/2025</span> <br />
      
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span> <br />
      <span>R$ 120,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 180,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span>Pagamento até 08/DEZ/2025</span> <br />
      
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span> <br />
      <span>R$ 140,00 CATEGORIA GI OU NOGI</span> <br />
      <span>R$ 200,00 COMBO CATEGORIA GI+NOGI</span> <br />
      <span style="display: block;">Pagamento até 11/DEZ/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>

    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 40,
    title: "XI Copa Londrina de Jiu Jitsu Gi 2025",
    link: "xi-copa-londrina-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/xi-copa-londrina-de-jiu-jitsu-2025/xi-copa-londrina-de-jiu-jitsu-2025-1080x1660-smartfone.jpg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 115,00 CATEGORIA GI</span><br />
       <span>R$ 35,00 ABSOLUTO</span><br />
      <span>R$ 140,00 COMBO CATEGORIA GI + ABSOLUTO</span><br />
      <span>Pagamento até 24/NOV/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 125,00 CATEGORIA GI</span><br />
      <span>R$ 45,00 ABSOLUTO</span><br />
      <span>R$ 150,00 COMBO CATEGORIA GI + ABSOLUTO</span><br />
      <span>Pagamento até 04/DEZ/2025</span><br />
     <br />
        <strong style="color: red; display: block;">
        OBS: CAMISA GRÁTIS PARA AS 100 PRIMEIRAS INSCRIÇÕES!
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 2,
    title: "Foz Open Confronto Internacional de Jiu Jitsu GI",
    link: "foz-open-confronto-internacional-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/foz-open-confronto-internacional-de-jiu-jitsu-2025/foz-open-confronto-internacional-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <strong style="color:red; display: block;">
        ⚠️ ATENÇÃO: Devido à mudança da data do evento por causa do ENEM, somente quem se inscreveu antes da alteração poderá pedir reembolso até 31/10/2025. Após essa data, não haverá reembolso.
      </strong><br />
 
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 140,00 CATEGORIA GI + CAMISETA</span><br />
      <span>R$ 100,00 CATEGORIA GI SEM CAMISETA</span><br />

      <span>Pagamento até 12/OUT/2025</span><br />
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 160,00 CATEGORIA GI + CAMISETA</span><br />
      <span>R$ 120,00 CATEGORIA GI SEM CAMISETA</span><br />

      <span>Pagamento até 20/NOV/2025</span><br />
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 165,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 04/DEZ/2025</span><br />

      <strong style="color:red; display: block;">
        OBS: As Camisetas ficarão disponíveis somente para o 1º
        e 2º LOTE.
      </strong><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADAS NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 8,
    title: "Copa Tomeya Sasahara de Jiu Jitsu Gi 2025",
    link: "copa-tomeya-sasahara-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/copa-tomeya-sasahara-de-jiu-jitsu-2025/copa-tomeya-sasahara-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />
      <span>Pagamento até 25/NOV/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 140,00 CATEGORIA GI</span><br />
      <span>Pagamento até 04/DEZ/2025</span><br />
      <span><b>R$ 120,00 CAMISA DO EVENTO</b></span><br />
      <span style="display: block;">Pagamento até 25/NOV/2025</span><br />

      <b style="color: red; display: block;">
        OBS: Para crianças e adolescente de projeto social as
        inscrições será no valor de R$90,00 reais! Desde que o
        professor de sua equipe comprove que são de projeto
        social! A Tratativa será diretamente com o responsável
        do evento.
      </b><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
 
  {
    id: 7,
    title: "Noroeste Open de Jiu Jitsu Gi e Nogi 2025",
    link: "noroeste-open-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/noroeste-open-de-jiu-jitsu-2025/noroeste-open-de-jiu-jitsu-2025.jpeg"),
    description: `
       <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 150,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 250,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 27/NOV/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADAS NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },

  {
    id: 5,
    title: "IV Open Paraguaçu Paulista de Jiu Jitsu Gi e Nogi",
    link: "iv-open-paraguacu-paulista-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/iv-open-paraguacu-paulista-de-jiu-jitsu-2025/iv-open-paraguacu-paulista-de-jiu-jitsu-2025.jpeg"),
    description: `
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 125,00 CATEGORIA GI ou NOGI</span><br />
      <span>R$ 125,00 ABSOLUTO GI </span><br />
      <span>R$ 158,00 COMBO CATEGORIA GI+ABSOLUTO GI </span><br />
      <span>R$ 195,00 COMBO CATEGORIA GI+NOGI </span><br />
      <span>R$ 255,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI</span><br />
      <span>Pagamento até 10/NOV/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 145,00 CATEGORIA GI ou NOGI</span><br />
      <span>R$ 145,00 ABSOLUTO GI </span><br />
      <span>R$ 178,00 COMBO CATEGORIA GI+ABSOLUTO GI</span><br />
      <span>R$ 215,00 COMBO CATEGORIA GI+NOGI </span><br />
      <span>R$ 275,00 COMBO CATEGORIA GI+NOGI+ABSOLUTO GI</span><br />
      <span style="display: block;">Pagamento até 20/NOV/2025</span><br />

      <strong style="color: red; display: block;">
        OBS: CAMISA GRÁTIS PARA AS 200 PRIMEIRAS INSCRIÇÕES!
      </strong><br />

      <strong>NÃO HAVERÁ LUTAS CASADAS NESSE EVENTO</strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 3,
    title: "Open Challenger de Jiu Jitsu Gi e Nogi",
    link: "open-challenger-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-challenger-de-jiu-jitsu-2025/open-challenger-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 130,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 11/NOV/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 4,
    title: "III Copa Champions Kids e I Copa Bushido Adulto de Jiu Jitsu Gi 2025",
    link: "iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025/iii-copa-champions-kids-e-i-copa-bushido-adulto-de-jiu-jitsu-2025.jpeg"),
    description: `
       <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />

      <span>Pagamento até 31/OUT/2025</span><br />
      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span>
       <br />
      <span>R$ 140,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 13/NOV/2025</span><br />
       <br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 1,
    title: "Estadual GF Team Amazonas de Jiu Jitsu Gi E NOGI",
    link: "estadual-gfteam-amazonas-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/estadual-gfteam-amazonas-de-jiu-jitsu-2025/estadual-gfteam-amazonas-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 75,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 130,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 06/11/2025</span><br />

      <strong style="display: block;">>INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong><br />
 
      <strong style="color:red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 11,
    title: "VII Rei da Praia de Jiu Jitsu Nogi",
    link: "vii-rei-da-praia-de-jiu-jitsu-no-gi-2025",
    image: require("../assets/images/tournaments/vii-rei-da-praia-de-jiu-jitsu-no-gi-2025/vii-rei-da-praia-de-jiu-jitsu-no-gi.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 80,00 CATEGORIA</span><br />
      <span>R$ 50,00 ABSOLUTO</span><br />
      <span style="display: block;">Pagamento até 26/OUT/2025</span><br />
   
      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
  },
  {
    id: 12,
    title: "XXXIII COPA ORLEY LOBATO DE JIU JITSU 2025",
    link: "xxxiii-copa-orley-lobato-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/xxxiii-copa-orley-lobato-de-jiu-jitsu-2025/xxxiii-copa-orley-lobato-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <strong style="color: red;">PARA OS 100 PRIMEIROS INSCRITOS</strong><br />
      <span>R$ 40,00 CATEGORIA GI </span> <br />
      <span>R$ 30,00 ABSOLUTO</span><br />
      <span> Pagamento até completar o limite de 100 inscritos</span><br />
      
      <b>LOTE 2 - (PREÇO PROMOCIONAL) </b><br />
      <span>R$ 50,00 CATEGORIA GI</span><br />
      <span>R$ 30,00 ABSOLUTO</span><br />
      <span>R$ 70,00 COMBO CATEGORIA GI + ABSOLUTO</span><br />
      <span>Pagamento até 30/SET/2025</span><br />
      
      <b>LOTE 3 - (PREÇO NORMAL) </b><br />
      <span>R$ 70,00 CATEGORIA GI</span><br />
      <span>R$ 40,00 ABSOLUTO</span><br />
      <span style="display: block;">R$ 100,00 COMBO CATEGORIA GI + ABSOLUTO</span><br />
      
      <strong style="color: red">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: true,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 13,
    title: "Open Paranavaí Brazilian de Jiu Jitsu Gi e Nogi",
    link: "open-paranavai-brazilian-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-paranavai-brazilian-de-jiu-jitsu-2025/open-paranavai-brazilian-de-jiu-jitsu-2025.jpeg"),
    description: `
     <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI OU NOGI</span><br />
      <span> R$ 170,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>R$85,00 CAMISA DO EVENTO</span><br />
      <span>Pagamento até 15/OUT/2025</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 150,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 200,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 23/OUT/2025</span><br />

      <strong style="color: red; display: block;">
        OBS: Venda das camisas ficarão disponíveis somente até o
        encerramento do 1º LOTE.
      </strong><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 14,
    title: "I COPA EU AMO PARINTINS DE JIU JITSU 2025",
    link: "i-copa-eu-amo-parintins-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/i-copa-eu-amo-parintins-de-jiu-jitsu-2025/i-copa-eu-amo-parintins-de-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>INSCRIÇÃO GRATUITA</b></span><br />
      <span>PERÍODO DE INSCRIÇÃO</span>   <br />
      <span style="display: block;">DE 03/SET/2025 ATÉ 15/SET/2025</span><br />
      
      <b style="display: block;">
        Obs: Ao completar 500 inscrições o sistema bloqueará imediatamente as inscrições.
      </b><br />
      
      <span style="color: red; display: block;">
        <b>VAGAS LIMITADAS A 500 INSCRIÇÕES, SOMANDO CATEGORIA E ABSOLUTO</b>
      </span><br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: true,
    maxInscricoes: 700,
    ajusteQuantidadeDeInscricoes: -4,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 15,
    title: "Copa Mestre do Açaí Kids de Jiu Jitsu",
    link: "copa-mestre-do-acai-kids-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/copa-mestre-do-acai-kids-de-jiu-jitsu-2025/copa-mestre-do-acai-kids-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 90,00 CATEGORIA GI</span><br />
      <span>Pagamento até 30/SET/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 16/OUT/2025</span><br />
      
      <strong>
        NÃO HAVERÁ INSCRIÇÃO PARA ABSOLUTO NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
  },
  {
    id: 16,
    title: "VIII LIJJAM combat de Jiu Jitsu Gi e Nogi",
    link: "viii-lijjam-combat-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/viii-lijjam-combat-de-jiu-jitsu-2025/viii-lijjam-combat-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>ÚLTIMO LOTE</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 130,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 01/OUT/2025</span><br />

      <strong style="color:red;">
        EVENTO DE LUTAS CASADAS
     </strong>
    `,
    isCasadas: true,
    isCacheBuster: true,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 17,
    title: "Copa Cianorte de Jiu Jitsu 2025",
    link: "copa-cianorte-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/copa-cianorte-de-jiu-jitsu-2025/copa-cianorte-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE - ÚNICO</b></span><br />
      <span>R$ 140,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 25/09/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 18,
    title: "Cascavel International Open de Jiu Jitsu Gi e Nogi",
    link: "open-cascavel-international-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-cascavel-international-de-jiu-jitsu-2025/open-international-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <strong style="color: red; display: block;">
        CAMISETAS PARA AS 50 PRIMEIRAS INSCRIÇÕES PAGAS!
      </strong><br />
      
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 150,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 20/07/2025</span><br />
      
      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 180,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 24/08/2025</span><br />
      
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 140,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 200,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 16/09/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 19,
    title: "Open Five de Jiu Jitsu GI E NOGI",
    link: "open-five-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-five-de-jiu-jitsu-2025/open-five-de-jiu-jitsu-2025.jpg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 105,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 165,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 06/09/2025</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 190,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 12/09/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red; display: block;">
        VALOR INSCRIÇÃO ABSOLUTO R$50,00
      </strong> <br />

      <strong style="color: red; display: block;">
        VALOR INSCRIÇÃO ABSOLUTO R$50,00
      </strong> <br />

      <strong style="color: red">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 20,
    title: "VIII Open Amazonas Top Team de Jiu Jitsu Gi e Nogi",
    link: "viii-open-amazonas-top-team-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/viii-open-amazonas-top-team-de-jiu-jitsu-2025/viii-open-amazonas-top-team-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 60,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 100,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 10/08/2025</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 100,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span>Pagamento até 25/08/2025</span><br />

      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 80,00 CATEGORIA GI OU NOGI</span><br />
      <span>R$ 120,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 03/09/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red; display: block;">
        VALOR INSCRIÇÃO ABSOLUTO R$50,00
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 21,
    title: "COPA LOBO BRAVO CRESOL DE JIU JITSU GI",
    link: "copa-lobo-bravo-cresol-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/copa-lobo-bravo-cresol-de-jiu-jitsu-2025/copa-lobo-bravo-cresol-de-jiujitsu.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 110,00 CATEGORIA</span><br />
      <span>Pagamento até 23/08/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 28/08/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO PARA ABSOLUTO ADULTO JÁ ESTÁ ABERTA
      </strong><br />

      <strong>
        INSCRIÇÃO ABSOLUTO JUVENIL SOMENTE NO DIA DO EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 22,
    title: "IX REI E RAINHA DA PRAIA - BEACH WRESTLING 2025",
    link: "ix-rei-e-rainha-da-praia-beach-wrestling-2025",
    image: require("../assets/images/tournaments/ix-rei-e-rainha-da-praia-beach-wrestiling-2025/ix-rei-e-rainha-da-praia-beach-wrestiling-2025.jpg"),
    description: `
      <BR />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 50,00 CATEGORIA KIDS/JUVENIL </span><br />
      <span>R$ 70,00 CATEGORIA ADULTO/MASTER </span><br />
      <span>R$ 50,00 ABSOLUTO </span><br />
      <span>R$ 110,00 COMBO CATEGORIA + ABSOLUTO</span><br />
      <span style="display: block;">Pagamento até 28/08/2025</span><br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 23,
    title: "II Copa Aquiles de Jiu Jitsu GI",
    link: "ii-copa-aquiles-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/ii-copa-aquiles-de-jiu-jitsu-2025/ii-copa-aquiles-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />
      <span>Pagamento até 17/07/2025</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA GI</span><br />

      <span>Pagamento até 14/08/2025</span><br />
      
      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 150,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 20/08/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 24,
    title: "I Copa Leão de Judá de Jiu Jitsu GI",
    link: "i-copa-leao-de-juda-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/i-copa-leao-de-juda-de-jiu-jitsu-2025/i-copa-leao-de-juda-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA GI</span><br />
      <span>Pagamento até 10/08/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 20/08/2025</span><br />
 
      <strong style="display: block;">
        NÃO HAVERÁ INSCRIÇÃO PARA ABSOLUTO NESSE EVENTO
      </strong><br />

      <strong style="color: red">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 25,
    title: "Copa Fronteira de Jiu Jitsu GI",
    link: "copa-fronteira-de-jiu-jistu-2025",
    image: require("../assets/images/tournaments/copa-fronteira-de-jiu-jitsu-2025/copa-fronteira-de-jiu-jitsu-2025.jpeg"),
    description: `
        <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />
      <span>Pagamento até 06/07/2025</span><br />

      <span style="color: red;"><b>LOTE 2 - PRORROGADO</b></span><br />
      <span>R$ 140,00 CATEGORIA GI</span><br />
      <span style="color: red; display: block;"><b>Pagamento até 31/07/2025 às 23:59h</b></span><br />
      
      <strong style="display: block;">INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong> <br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 26,
    title: "Open Candói de Jiu Jitsu GI",
    link: "open-candoi-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/open-candoi-de-jiu-jitsu-2025/open-candoi-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA GI</span><br />
      <span>Pagamento até 05/07/2025</span><br />
      
      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 21/07/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 27,
    title: "I Valente Kids de Jiu Jitsu GI",
    link: "i-valente-kids-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/i-valente-kids-de-jiu-jitsu-2025/i-valente-kids-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 90,00 CATEGORIA GI</span><br />
      <span>Pagamento até 10/07/2025</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 110,00 CATEGORIA GI</span><br />
      <span style="display: block;">Pagamento até 24/07/2025</span> <br />

      <strong style="display: block;">
        NÃO HAVERÁ INSCRIÇÃO PARA ABSOLUTO NESSE EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 28,
    title: "V OPEN TERRA SANTA DE JIU JITSU 2025",
    link: "v-open-terra-santa-de-jiu-jitsu-2025",
    image: require("../assets/images/tournaments/v-open-terra-santa-de-jiu-jitsu-2025/v-open-terra-santa-de-jiu-jitsu-2025.jpeg"),
    description: `
      <br />
      <span><b>LOTE ÚNICO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA GI OU NOGI</span><br />
      <span>Pagamento até 15/JUL/2025</span><br />

      <b>PREÇO PROMOCIONAL</b><br />
      <span>R$ 100,00 COMBO CATEGORIA GI+NOGI</span><br />
      <span style="display: block;">Pagamento até 15/JUL/2025</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 29,
    title: "III Open Rocha e Moraes",
    link: "iii-open-rocha-e-moraes-de-jiu-jitsu",
    image: require("../assets/images/tournaments/iii-open-rocha-e-moraes-de-jiu-jitsu/iii-open-rocha-e-moraes-de-jiu-jitsu.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 50,00 CATEGORIA</span><br />
      <span>Pagamento até 29/11/2024</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 60,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 10/12/2024</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <span>GRÁTIS PARA OS MEDALHISTAS DAS CATEGORIAS</span>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 30,
    title: "1º Open Laranjeiras do Sul de Jiu Jitsu",
    link: "i-open-laranjeiras-do-sul-de-jiu-jitsu",
    image: require("../assets/images/tournaments/i-open-laranjeiras-do-sul-de-jiu-jitsu/i-open-laranjeiras-do-sul-de-jiu-jitsu.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA</span><br />
      <span>Pagamento até 30/10/2024</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA</span><br />
      <span>Pagamento até 12/11/2024</span><br />

      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 14/11/2024</span><br />
    
      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 31,
    title: "29º Copa Luis Neto de Jiu Jitsu GI e NOGI",
    link: "xxix-copa-luis-neto-jiu-jitsu",
    image: require("../assets/images/tournaments/xxix-copa-luis-neto-jiu-jitsu/xxix-copa-luis-neto-jiu-jitsu.jpeg"),
    description: `
      <br />
      <span><b>INSCRIÇÃO - (PREÇO PROMOCIONAL)</b></span><br />
      <span style="display: block;">R$ 90,00 COMBO CATEGORIA GI+NOGI</span><br />

      <span><b>INSCRIÇÃO - (PREÇO NORMAL)</b></span><br />
      <span>R$ 50,00 CATEGORIA GI</span><br />

      <span>R$ 50,00 CATEGORIA NOGI</span><br />
      <span style="display: block;"><b>Pagamento até 05/11/2024 (TERÇA-FEIRA</b>)</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 32,
    title: "2° Copa Champions Kids de Jiu Jitsu",
    link: "ii-copa-champions-kids-de-jiu-jitsu",
    image: require("../assets/images/tournaments/ii-copa-champions-kids-de-jiu-jitsu/ii-copa-champions-kids-de-jiu-jitsu.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA</span><br />
      <span>Pagamento até 09/10/2024</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 16/10/2024</span><br />

      <strong style="display: block;">
        NÃO HAVERÁ INSCRIÇÃO PARA ABSOLUTO NESTE EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 33,
    title: "Copa Cianorte de Jiu Jitsu",
    link: "copa-cianorte-de-jiu-jitsu",
    image: require("../assets/images/tournaments/copa-cianorte-de-jiu-jitsu/copa-cianorte-de-jiu-jitsu.jpeg"),
    description: `
        <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA</span><br />
      <span>Pagamento até 10/09/2024</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA(PRORROGADO)</span><br />
      <span style="display: block;">Pagamento até 19/09/2024</span><br />

      <strong>
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 34,
    title: "I ORIXICOMBAT OPEN JIU JITSU",
    link: "i-orixicombat-open-jiu-jitsu",
    image: require("../assets/images/tournaments/i-orixicombat-open-jiu-jitsu/i-orixicombat-open-jiu-jitsu.jpg"),
    description: `
    <br />
     <span style="display: block;">GI R$ 70.00</span><br />
  `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 35,
    title: "VI Rei da Praia No Gi 2024",
    link: "vi-rei-da-praia-de-jiu-jitsu-no-gi",
    image: require("../assets/images/tournaments/vi-rei-da-praia-de-jiu-jitsu-no-gi/vi-rei-da-praia-de-jiu-jitsu-no-gi.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 70,00 CATEGORIA</span><br />
      <span>R$ 45,00 ABSOLUTO</span><br />
      <span>Pagamento até 15/09/2024</span><br />

      <span><b>LOTE 2 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 80,00 CATEGORIA</span><br />
      <span>R$ 50,00 ABSOLUTO</span><br />
      <span>Pagamento até 25/09/2024</span><br />

      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 90,00 CATEGORIA</span><br />
      <span>R$ 60,00 ABSOLUTO</span><br />
      <span style="display: block;">Pagamento até 30/09/2024</span><br />
 
      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 36,
    title: "VII Open Amazonas Top Team de Jiu Jitsu GI",
    link: "vii-open-amazonas-top-team-de-jiu-jitsu",
    image: require("../assets/images/tournaments/vii-open-amazonas-top-team-de-jiu-jitsu/vii-open-amazonas-top-team-de-jiu-jitsu.jpeg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 40,00 CATEGORIA</span><br />
      <span>Pagamento até 31/07/2024</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 50,00 CATEGORIA</span><br />
      <span>Pagamento até 31/08/2024</span><br />

      <span><b>LOTE 3 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 60,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 10/09/2024</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <span style="display: block;">R$ 40,00 ABSOLUTO</span><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 37,
    title: "COPA LOBO BRAVO CRESOL DE JIU JITSU",
    link: "copa-lobo-bravo-cresol-de-jiu-jitsu",
    image: require("../assets/images/tournaments/copa-lobo-bravo-cresol-de-jiu-jitsu/copa-lobo-bravo-cresol-de-jiu-jitsu.jpg"),
    description: `
      <br />
      <span><b>LOTE 1 - (PREÇO PROMOCIONAL)</b></span><br />
      <span>R$ 100,00 CATEGORIA</span><br />
      <span>Pagamento até 24/08/2024</span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 120,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 27/08/2024</span><br />
    
      <strong style="display: block;">
        INSCRIÇÃO PARA ABSOLUTO ADULTO JÁ ESTA ABERTA
      </strong><br />

      <strong>
        INSCRIÇÃO ABSOLUTO JUVENIL SOMENTE NO DIA DO EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 38,
    title: "Copa Fronteira de Jiu Jitsu",
    link: "copa-fronteira-de-jiu-jitsu",
    image: require("../assets/images/tournaments/copa-fronteira-de-jiu-jitsu/copa-fronteira-de-jiu-jitsu.jpg"),
    description: `
      <br />
      <span style="color: red;"><b>LOTE 1 - (ENCERRADO)</b></span><br />

      <span><b>LOTE 2 - (PREÇO NORMAL)</b></span><br />
      <span>R$ 130,00 CATEGORIA</span><br />
      <span style="display: block;">Pagamento até 21/08/2024</span><br />

      <strong style="display: block;">
        INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO
      </strong><br />

      <strong style="color: red;">
        NÃO HAVERÁ LUTAS CASADA NESSE EVENTO
      </strong>
  `,

    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 0,
    ajusteQuantidadeDeInscricoes: 0,
    isClosed: true, // para saber que o botão deve mostrar "Encerrado"
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 0
  },
  {
    id: 39,
    title: "COPA TORNEIO FÁCIL DE JIU JITSU GI",
    link: "copa-torneio-facil-de-jiu-jitsu",
    image: require("../assets/images/tournaments/copa-torneio-facil-de-jiu-jitsu/copa-torneio-facil-de-jiu-jitsu-old.jpg"),
    description: `
      <br />
      
      <br />
    `,
    isCacheBuster: false,
    amountRegistrationPaid: false,
    maxInscricoes: 1000,
    ajusteQuantidadeDeInscricoes: 5,
    isClosed: false, // para saber que o botão deve mostrar "Encerrado",
    IsQuantidadeInscricaoEstatica: false,
    quantidadeInscricaoEstatica: 1000
  },
  
];
